export default "__VITE_ASSET__AnaEtZ34__"